<template>
  <div class="customer-edit-container">
      <Breadcrumb :company="company_uid" :project="user_project" lastname="Edit Customer"/>    
      <CompanyRailsbankForm :formData="customerForm" v-if="customerForm && venderType === 'railsbank' && customerForm.type === 'company'" />
      <PersonalRailsbankForm :formData="customerForm" v-if="customerForm && venderType === 'railsbank' && customerForm.type === 'person'" />
      <CompanyModulrForm :formData="customerForm" v-if="customerForm && venderType === 'modulr' && customerForm.type === 'company'" />
      <PersonalModulrForm :formData="customerForm" v-if="customerForm && venderType === 'modulr' && customerForm.type === 'person'" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CompanyRailsbankForm from './components/company-railsbank-form.vue'
import PersonalRailsbankForm from './components/personal-railsbank-form.vue'
import CompanyModulrForm from './components/company-modulr-form.vue'
import PersonalModulrForm from './components/personal-modulr-form.vue'
import Breadcrumb from "@/components/Breadcrumb";
import { findIndex } from "@/utils"
import {
  getCustomerBy,
} from "@/api/customer";
export default {

    components: {
        CompanyRailsbankForm,
        PersonalRailsbankForm,
        PersonalModulrForm,
        CompanyModulrForm,
        Breadcrumb
    },
     computed:{
    ...mapGetters(['user_project','company_uid', 'company_name'])
  },
    data(){
        return {
            venderType: "railbank",
            customerForm: null
        }
    },
    methods:{
        sortDefault(data){
            if(data.kyc.associates){
                let index1 = findIndex(data.kyc.associates, 'BENE_OWNER', 'position')
                let index2 = findIndex(data.kyc.associates, 'DIRECTOR', 'position')
                let data1 = data.kyc.associates[index1]
                let data2 = data.kyc.associates[index2]
                let newData = [data1, data2]

                data.kyc.associates.splice(index1, 1)
                data.kyc.associates.splice(index2, 1)
                
                data.kyc.associates.map(item => {
                    newData.push(item)
                })

                data.kyc.associates = newData
            }


            return data
        },
        getDataToEdit(uid) {
            const loading = this.$notifyloading("Loading data...");
            getCustomerBy(uid).then(({ result, data }) => {
                loading.close();
                if (result) {
                    this.customerForm = this.sortDefault(data)
                    this.venderType = data.vender_type || "railsbank";
                    
                }
            });
        },
    },
    mounted(){
        this.getDataToEdit(this.$route.params.uid);
    },
    
}
</script>

<style>

</style>